module.exports = __webpack_public_path__ + "static/media/contactform.ef29088a.png";